import { render, staticRenderFns } from "./PilaDocumentos.vue?vue&type=template&id=68bf9fdb&scoped=true"
import script from "./PilaDocumentos.vue?vue&type=script&lang=js"
export * from "./PilaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./PilaDocumentos.vue?vue&type=style&index=0&id=68bf9fdb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf9fdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bf9fdb')) {
      api.createRecord('68bf9fdb', component.options)
    } else {
      api.reload('68bf9fdb', component.options)
    }
    module.hot.accept("./PilaDocumentos.vue?vue&type=template&id=68bf9fdb&scoped=true", function () {
      api.rerender('68bf9fdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/PilaDocumentos.vue"
export default component.exports